import { GlobalConfig } from "stores/wizard/config/staticConfigs/global";

export const globalConfig: GlobalConfig = {
  navigation: {
    defaultLob: "wizard-hotel-pwa-v2",
    activeLob: "wizard-hotel-pwa-v2",
  },
  packageWith3PP: false,
  useLastSearchForMultiLOB: false,
  heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/06/25/US_beach_ex.jpg",
};
